import { createContext } from "react"

export const BundleMicroContext = createContext<Function>(() => "No bundle component found")
